import { useEcomProductContext } from '@/context/ecomProductContext';
import dlv from 'dlv';

export const useEcomProducts = () => {
  const { state } = useEcomProductContext();
  return dlv(state, 'productData', {});
};

const useEcomProduct = (materialId: string) => {
  const products = useEcomProducts();
  return dlv(products, `${materialId}`, {});
};

export default useEcomProduct;
